import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FaGithub, FaLinkedin, FaAngellist } from "react-icons/fa";
import Floating from "./FloatingButton";
import LanguageSwitcher from "./languageSwitcher";
import { useLanguage } from "../utils/LanguageContext";
import en from "../utils/languages/en.jsx";
import fr from "../utils/languages/fr.jsx";

const Header = ({ handleThemeSwitch, theme }) => {
  const [header, setHeader] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useLocation();
  const { language } = useLanguage();

  const translations = {
    en,
    fr,
  };

  const currentTranslations = translations[language];

  const openMenu = () => {
    setOpen(!open);
  };

  function handleLinkClick() {
    setOpen(false);
  }

  const handleChangeBackgroundOnScroll = () => {
    if (window.scrollY >= 80 && window.location.pathname === "/") {
      setHeader(true);
    } else {
      setHeader(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleChangeBackgroundOnScroll);
    return () => {
      window.removeEventListener("scroll", handleChangeBackgroundOnScroll);
    };
  }, [header]);

  useEffect(() => {
    switch (navigate.hash) {
      case "#projects":
        document
          .getElementById("projects")
          .scrollIntoView({ behavior: "smooth" });
        break;
      case "#contact":
        document
          .getElementById("contact")
          .scrollIntoView({ behavior: "smooth" });
        break;
      case "#about":
        document.getElementById("about").scrollIntoView({ behavior: "smooth" });
        break;
      case "#tech":
        document.getElementById("tech").scrollIntoView({ behavior: "smooth" });
        break;
      default:
        document.getElementById("home").scrollIntoView({ behavior: "smooth" });
        break;
    }
  }, [navigate]);

  const data = {
    name: "Portfolio",
    menu: currentTranslations.menu,
    icons: [
      {
        id: 1,
        icon: <FaGithub className="dark:text-blue-600" />,
        url: "https://github.com/mwafrika",
      },
      {
        id: 2,
        icon: <FaLinkedin className="dark:text-blue-600" />,
        url: "https://www.linkedin.com/in/mwafrika-mufungizi",
      },
      {
        id: 3,
        icon: <FaAngellist className="dark:text-blue-600" />,
        url: "https://angel.co/u/mwafrika-mufungizi",
      },
    ],
  };

  return (
    <header
      className={`${
        header
          ? "header active shadow-md transition-all duration-200 ease-in-out text-white"
          : "header"
      } flex w-full h-20 md:h-20 py-8 px-4 items-center pl-8 md:pl-2 bg-slate-900 text-gray-400 dark:text-white justify-around md:justify-between fixed z-50 mx-auto top-0 left-0 right-0 
    
      `}
    >
      <div className="xxxs:hidden xxs:hidden xs:hidden md:hidden lg:flex lg:ml-6 text-white row-start-1 row-end-2 col-start-1 col-end-2">
        {data.name}
      </div>
      {/* <LanguageSwitcher /> */}

      <div className="xxxs:hidden xxs:hidden xs:hidden row-start-1 row-end-2 col-start-5 col-end-6 xxxs:col-start-2 xxxs:col-end-6 xxs:col-start-2 xxs:col-end-6 xs:col-start-2 xs:col-end-6">
        <ul className="flex justify-around gap-x-6 md:gap-x-1">
          {data.menu.map(({ id, name, url }) => (
            <li
              key={id}
              className="hover:transition-all duration-200 ease transform hover:scale-110 hover:bg-slate-600 hover:rounded-full px-3 py-1"
            >
              <a href={url} rel="noopener noreferrer">
                <span className="text-xl rounded-full text-white">{name}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* mobile menu */}

      <div className="container flex flex-wrap items-center justify-between mx-auto md:hidden">
        {/* Hamburger button */}
        <button
          id="hamburger-button"
          className="fixed top-6 z-50 right-6 block lg:hidden  focus:outline-none"
          onClick={openMenu}
        >
          <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
            <path
              className="text-white"
              fillRule="evenodd"
              d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"
            />
          </svg>
        </button>

        {/* Overlay */}
        {open && (
          <div
            id="overlay"
            className="fixed z-40 top-0 left-0 w-screen h-screen bg-gray-900 opacity-50 cursor-pointer"
            onClick={openMenu}
          ></div>
        )}

        <div
          id="menu"
          className={`fixed z-50 top-0 left-0 w-full h-full flex items-center justify-center ${
            open ? "" : "hidden"
          }`}
        >
          <ul className="flex w-[90%] h-[95%] flex-col mt-4 rounded-lg bg-gray-50 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0 md:bg-transparent dark:bg-gray-800 md:dark:bg-transparent dark:border-gray-700">
            {data.menu.map(({ id, name, url }) => (
              <li key={id}>
                <a
                  href={url}
                  onClick={handleLinkClick}
                  className="block py-2 pl-3 pr-4 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-gray-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
                >
                  {name}
                </a>
              </li>
            ))}
            <span
              onClick={handleLinkClick}
              className="fixed top-6 right-6 py-2 pl-3 pr-4 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-gray-700 md:p-0 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
            >
              X
            </span>
          </ul>
        </div>
      </div>

      <div className="xxxs:hidden xxs:hidden xs:hidden row-start-1 row-end-2 md:mr-[50px] col-start-5 col-end-6 xxxs:col-start-2 xxxs:col-end-6 xxs:col-start-2 xxs:col-end-6 xs:col-start-2 xs:col-end-6">
        <ul className="flex justify-around md:justify-between gap-x-6 md:gap-x-1">
          {data.icons.map(({ id, icon, url }) => (
            <li
              key={id}
              className="hover:transition-all duration-200 ease transform hover:scale-110 hover:bg-slate-600 hover:rounded-full p-3"
            >
              <a href={url} target="_blank" rel="noopener noreferrer">
                <span className="text-3xl rounded-full text-white dark:text-white">
                  {icon}
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className="mr-10">
        <LanguageSwitcher />
      </div>
      <button
        type="button"
        onClick={handleThemeSwitch}
        // top-6 right-16
        className="bg-indigo-500 text-lg p-1 rounded-md md:flex fixed top-28 right-4 md:right-14"
      >
        {theme === "dark" ? "🌞" : "🌙"}
      </button>
      <Floating />
    </header>
  );
};

export default Header;
